import { useState } from "react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { CONSULT_TYPES, consultService, live } from "@/lib/clinic";
import { clinicScope } from "@/lib/scope";

function PriceRow({ k, svc, canEdit, onSave }) {
  const { t, money } = useApp();
  const [v, setV] = useState(svc ? String(svc.price) : "");
  const label = t(k.startsWith("sp_") ? k : `consult_${k}`);
  const commit = () => { if (v !== "" && Number(v) !== (svc?.price ?? -1)) onSave(k, label, Number(v)); };
  return (
    <div className="flex items-center gap-2 rounded border border-[#CCCCCC] bg-white px-3 py-1.5" data-testid={`consult-price-${k}`}>
      <span className="flex-1 text-sm font-bold">{label}</span>
      {canEdit ? (
        <input dir="ltr" inputMode="decimal" value={v} onChange={(e) => setV(e.target.value)} onBlur={commit} onKeyDown={(e) => e.key === "Enter" && e.target.blur()} placeholder="0"
          className="h-9 w-28 rounded border border-[#CCCCCC] px-2 text-end text-sm" data-testid={`consult-price-input-${k}`} />
      ) : <span dir="ltr" className="text-sm">{svc ? money(svc.price) : t("not_set")}</span>}
    </div>
  );
}

export default function ConsultPricesTab() {
  const { t, view, dispatch, can } = useApp();
  const services = live(view.services);
  const canEdit = can("inventory");
  const scope = clinicScope(view.shop);
  const save = (k, label, price) => {
    if (dispatch("service.upsert", { id: consultService(k), name: label, price, category: "consultation", duration: 0, consult_type: k })) toast.success(t("saved"));
  };
  return (
    <div className="space-y-3" data-testid="consult-prices-tab">
      <p className="text-sm text-[#555]">{t("consult_prices_hint")}</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-1.5">
        {CONSULT_TYPES.filter((k) => !scope || !k.startsWith("sp_") || k === `sp_${scope}`).map((k) => <PriceRow key={k} k={k} svc={services.find((s) => s.id === consultService(k))} canEdit={canEdit} onSave={save} />)}
      </div>
    </div>
  );
}
